<template>
  <div id="default-container">
    <nav class="blue-grey darken-3">
      <a
        href="#"
        data-target="slide-out"
        class="sidenav-trigger show-on-medium-and-down"
        @click="resetCollapsedState()"
      >
        <font-awesome-icon icon="bars" size="2x" fixed-width />
      </a>
      <a
        href="#"
        id="desktop-nav-toggle"
        class="hide-on-med-and-down"
        @click="toggleNav()"
      >
        <font-awesome-icon icon="bars" size="2x" fixed-width />
      </a>
      <div class="right">
        <span
          v-if="user" 
          class="current-user"
        >
          {{ user.prenom }} {{ user.nom }} ({{ user.utam }})
        </span>
      </div>
    </nav>
    <ul id="slide-out"
        class="sidenav sidenav-fixed blue-grey lighten-4">
        <li class="logo-container center-align">
            <img class="logo"
                 src="../assets/logo-dpsm.png">
        </li>
        <li>
            <router-link to="/"
                         class="waves-effect">
                <font-awesome-icon icon="home" fixed-width />
                Accueil
            </router-link>
        </li>
        <li v-if="hasRole('Utilisateur collecte DPSM')"
            class="no-padding">
            <ul class="collapsible collapsible-accordion">
                <li @click="showCollapsibleBody($event)">
                    <a class="collapsible-header waves-effect">
                        <font-awesome-icon icon="chevron-right" fixed-width />
                        Assistants de saisie (ASIS)
                    </a>
                    <div class="collapsible-body">
                        <ul>
                            <li>
                                <router-link to="/asis"
                                             class="waves-effect">
                                    <font-awesome-icon icon="folder-open" fixed-width />
                                    Les Assistants
                                </router-link>
                            </li>
                            <li>
                                <router-link to="/dashboard"
                                             class="waves-effect">
                                    <font-awesome-icon icon="folder-open" fixed-width />
                                    Tableau de bord
                                </router-link>
                            </li>
                            <li>
                                <router-link to="/profils-saisie"
                                             class="waves-effect">
                                    <font-awesome-icon icon="folder-open" fixed-width />
                                    Profils de saisie
                                </router-link>
                            </li>
                            <li>
                                <router-link to="/suggestions"
                                             class="waves-effect">
                                    <font-awesome-icon icon="folder-open" fixed-width />
                                    Suggestions
                                </router-link>
                            </li>
                            <KeyAsis/>
                        </ul>
                    </div>
                </li>
            </ul>
        </li>
        <li v-if="hasRole('Utilisateur collecte DPSM') || hasRole('Administrateur collecte DPSM') || hasRole('Administrateur DPSM')" class="no-padding">
            <ul class="collapsible collapsible-accordion">
                <li @click="showCollapsibleBody($event)">
                    <a class="collapsible-header waves-effect">
                        <font-awesome-icon icon="chevron-right" fixed-width />
                        Formulaires de saisie
                    </a>
                    <div class="collapsible-body">
                        <ul>
                            <!--<li>
                                <router-link v-if="hasRole('Utilisateur collecte DPSM')"
                                             to="/listfsd"
                                             class="waves-effect">
                                    <font-awesome-icon icon="folder-open" fixed-width />
                                    Les formulaires
                                </router-link>
                            </li>-->
                            <li>
                                <router-link v-if="hasRole('Utilisateur collecte DPSM')"
                                             to="/generatefsd"
                                             class="waves-effect">
                                    <font-awesome-icon icon="file-import" fixed-width />
                                    Générer un formulaire
                                </router-link>
                            </li>
                            <!--<li>
                                <router-link v-if="hasRole('Utilisateur collecte DPSM')"
                                             to="/checkfsd"
                                             class="waves-effect">
                                    <font-awesome-icon icon="file-medical-alt" fixed-width />
                                    Vérifier un formulaire
                                </router-link>
                            </li>
                            <li>
                                <router-link v-if="hasRole('Utilisateur collecte DPSM')"
                                             to="/savefsd"
                                             class="waves-effect">
                                    <font-awesome-icon icon="save" fixed-width />
                                    Sauvegarder un formulaire
                                </router-link>
                            </li>-->
                            <li>
                                <router-link v-if="hasRole('Utilisateur collecte DPSM')"
                                             to="/checkfsd/load"
                                             class="waves-effect">
                                    <font-awesome-icon icon="file-upload" fixed-width />
                                    Verser un lot de données
                                </router-link>
                            </li>
                            <li>
                                <router-link to="/versements"
                                             class="waves-effect">
                                    <font-awesome-icon icon="list-ul" fixed-width />
                                    Les versements
                                </router-link>
                            </li>
                            <!--<li>
                                <router-link to="/submitfsd"
                                             class="waves-effect">
                                    <font-awesome-icon icon="envelope" fixed-width />
                                    Soumettre un formulaire
                                </router-link>
                            </li>-->
                        </ul>
                    </div>
                </li>
            </ul>
        </li>

        <li v-if="hasRole('Utilisateur collecte DPSM')"
            class="no-padding">
            <ul class="collapsible collapsible-accordion">
                <li @click="showCollapsibleBody($event)">
                    <a class="collapsible-header waves-effect">
                        <font-awesome-icon icon="chevron-right" fixed-width />
                        Appareils de mesure
                    </a>
                    <div class="collapsible-body">
                        <ul>
                            <li>
                                <router-link to="/materiel"
                                             class="waves-effect">
                                    <font-awesome-icon icon="tachometer-alt" fixed-width />
                                    Les appareils
                                </router-link>
                            </li>
                        </ul>
                    </div>
                </li>
            </ul>
        </li>
        <li v-if="hasRole('Administrateur collecte DPSM') || hasRole('Administrateur DPSM')"
            class="no-padding">
            <ul class="collapsible collapsible-accordion">
                <li @click="showCollapsibleBody($event)">
                    <a class="collapsible-header waves-effect">
                        <font-awesome-icon icon="chevron-right" fixed-width />
                        Acquisitions périodiques
                    </a>
                    <div class="collapsible-body">
                        <ul>
                            <li>
                                <router-link to="/acquisition"
                                             class="waves-effect">
                                    <font-awesome-icon icon="list-ul" fixed-width />
                                    Tableau des configurations
                                </router-link>
                            </li>
                        </ul>
                    </div>
                </li>
            </ul>
        </li>
        <li v-if="this.lecteurDonneesSurveillanceAutres || (hasRole('Utilisateur collecte DPSM') ||  hasRole('Administrateur collecte DPSM') || hasRole('Administrateur DPSM'))" class="no-padding">
            <router-link to="/surveillance"
                         class="waves-effect">
                <font-awesome-icon icon="fa fa-chart-column" fixed-width />
                Afficher les données
            </router-link>
        </li>
        <li v-if="this.lecteurDonneesSurveillanceTopos || (hasRole('Utilisateur collecte DPSM') || hasRole('Administrateur collecte DPSM') || hasRole('Administrateur DPSM'))" class="no-padding">
            <router-link to="/surveillanceTopo"
                         class="waves-effect">
                <font-awesome-icon icon="fa fa-chart-line" fixed-width />
                Afficher les données topo
            </router-link>
        </li>
        <li v-if="hasRole('Utilisateur collecte DPSM') || hasRole('Administrateur collecte DPSM') || hasRole('Administrateur DPSM')" class="no-padding">
            <router-link to="/rapports"
                         class="waves-effect">
                <font-awesome-icon icon="fa fa-file-excel" fixed-width />
                Créer des rapports
            </router-link>
        </li>
        <li>
            <div class="divider blue-grey lighten-3" />
        </li>
        <li>
            <a class="waves-effect"
               @click="logout"
               href="#!"
               id="btn-deconnexion">
                <font-awesome-icon icon="power-off" fixed-width />
                Déconnexion
            </a>
        </li>
        <li class="version-number" id="version-number"  @click="downloadPdf">
                Portail {{ versionPortail }} - API {{ versionApi }}
        </li>
    </ul>
    <div id="main-content">
      <div id="slot-container">
        <slot />
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { rolesHelper } from '../helpers'
import gsap from 'gsap'
import { authService, bdltService, proxyService, utilisateursService } from "@/services"
import router from "@/router/router";
import KeyAsis from "@/components/KeyAsis.vue"

export default {
    components: {KeyAsis},
    data: function(){
        return {
            asisAssistantShowed: false,
            lecteurDonneesSurveillanceTopos: false,
            lecteurDonneesSurveillanceAutres: false
        }
    },
    computed: {
        ...mapGetters('authentication', [
            'user'
        ]),
        versionPortail: function () {
            return process.env.VUE_APP_VERSION
        },
        versionApi: function () {
            return this.$store.getters['authentication/apiVersion']
        }
    },
    methods: {
        hasRole: function (role) {
            return rolesHelper.hasRole(role)
        },
        logout: function () {
            this.$store.dispatch('authentication/logout')
        },
        toggleNav: function () {
            let navbar = document.querySelector('#slide-out')
            let container = document.querySelector('#default-container')

            if (container.classList.contains('nav-collapsed')) {
                gsap.to(navbar, 0.2, { x: '0%',
                    onStart: function () {
                        container.classList.remove('nav-collapsed')
                    }
                })
            } else {
                gsap.to(navbar, 0.2, { x: '-105%',
                    onStart: function () {
                        container.classList.add('nav-collapsed')
                    }
                })
            }
        },
        resetCollapsedState: function () {
            let container = document.querySelector('#default-container')
            container.classList.remove('nav-collapsed')
        },
        showCollapsibleBody(event) {
            // Si on a cliqué sur un bouton modal ou à l'intérieur de la modal, on ne touche pas au collapsible
            if (event.target.closest('.modal-backdrop') || event.target.closest('.open-modal-btn')) {
                return
            }

            const element = event.currentTarget.querySelector(".collapsible-body")

            element.classList.toggle("showCollapsible")
        },

        downloadPdf() {
            const chemin = process.env.VUE_APP_CHEMIN_PDF;
            const nom = process.env.VUE_APP_NOM_PDF;
            const pdfUrl = `${chemin}/${nom}`;

            const link = document.createElement('a');
            link.href = pdfUrl;
            link.download = nom;
            link.click();
        }

    },
    async mounted () {
        // On récupère les infos de rôles de l'utilisateur (rôle lecteur)
        const user = localStorage.getItem('user')

        if (user && user != undefined) {
            const userId = JSON.parse(user).id

            utilisateursService.getInfosLecteurSurveillance(userId).then(data => {
                if (data && data.length > 0) {
                    data.forEach(role => {
                        if (role.isLecteur && role.accesDonneesTopos) {
                            this.lecteurDonneesSurveillanceTopos = true
                        }

                        if (role.isLecteur && role.accesDonneesAutres) {
                            this.lecteurDonneesSurveillanceAutres = true
                        }
                    })
                }
            })
        }
    }


}
</script>
<style scoped>
.logo {
    width: 200px;
}

#default-container{
    padding-left: 300px;
    transition: .2s padding-left;
}
#default-container.nav-collapsed{
    transition: .2s padding-left;
    padding-left: 0px;
}
#default-container.nav-collapsed #slide-out{
    transition: .2s transform;
    transform: translateX(-105%) !important;
}
nav{
    padding-left: 10px;
    padding-right: 10px;
}

.sidenav a svg{
    margin-right: 20px;
}

.sidenav .collapsible-header, .sidenav.fixed .collapsible-header {
    padding: 0 32px;
}

#desktop-nav-toggle{
    display: inline-block;
}

.version-number{
    bottom: 55px;
    color: #a5a5a5;
    margin-left: 10px;
    font-size: 0.8em;
    text-transform: uppercase;
    cursor: pointer;
}
.version-number::before{
    content: "V"
}
.showCollapsible {
    display: unset !important;
}

@media only screen and (max-width : 992px) {
    #default-container{
        padding-left: 0px;
    }
}
</style>
